import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UtilsService } from "../../auth/service/utils.service";
import { locale as productsIt } from "./i18n/products.lang-it";
import productsSettingsLinks from "./products.settings-list";
import { RouterModule } from "@angular/router";
import productsRoutes from "./products.routes";
import productsMenu from "./products.menu";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { TranslateModule } from "@ngx-translate/core";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgbModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { ExtendedModule } from "@angular/flex-layout";
import { CoreCommonModule } from "../../../@core/common.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { ProductsListComponent } from "./pages/products/products-list/products-list.component";
import { ProductsDetailComponent } from "./pages/products/products-detail/products-detail.component";
import { ProductFormComponent } from "./components/modals/product-form/product-form.component";
import { ProductDealsCreateComponent } from "./pages/deals/product-deals-create/product-deals-create.component";
import { ProductDealsEditComponent } from "./pages/deals/product-deals-edit/product-deals-edit.component";
import { LayoutModule } from "../../layout/layout.module";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { ProductCommissionCreateComponent } from './pages/commission/product-commission-create/product-commission-create.component';
import { ProductCommissionEditComponent } from './pages/commission/product-commission-edit/product-commission-edit.component';
import { ProductsCostListComponent } from './pages/products-cost-list/products-cost-list.component';
import { ProductDealsDuplicateComponent } from './pages/deals/product-deals-duplicate/product-deals-duplicate.component';
import { CustomerModule } from "../customer/customer.module";

@NgModule({
  declarations: [ProductsListComponent, ProductsDetailComponent, ProductFormComponent, ProductDealsCreateComponent, ProductDealsEditComponent, ProductCommissionCreateComponent, ProductCommissionEditComponent, ProductsCostListComponent, ProductDealsDuplicateComponent],
  exports: [ProductFormComponent],
  imports: [
    RouterModule.forChild(productsRoutes),
    CommonModule,
    NgSelectModule,
    CoreCommonModule,
    ContentHeaderModule,
    TranslateModule,
    ExtendedModule,
    Ng2FlatpickrModule,
    NgxDatatableModule,
    NgbTooltipModule,
    AngularEditorModule,
    NgbModule,
    LayoutModule,
    CustomerModule
  ]
})
export class ProductsModule {
  constructor(private _utils: UtilsService) {
    this._utils.initModule("products", productsIt, productsMenu, productsSettingsLinks);
  }
}
